import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { CmsList, CreateCms, UpdateCms } from "./pages";

export const CmsRouter = [
  <Route
    path="/cms"
    element={
      <ProtectedRoute roles={["Any"]}>
        <CmsList />
      </ProtectedRoute>
    }
  />,

  <Route path="/cms-item">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateCms />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateCms />
        </ProtectedRoute>
      }
    />
  </Route>,
];
